export const MULTISELECT_ALL_OPTION = {
  label: "All",
  value: "all",
};
